<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
    >
      {{ message }}
      <v-btn dark text @click="snackbar = false"> CLOSE </v-btn>
    </v-snackbar>
    <v-row>
      <v-spacer></v-spacer>
      <!--      <v-col cols="3" v-if="canCreateMillingCharge">-->
      <v-col cols="3" v-if="canCreateWarehouseCharge">
        <v-btn
          color="#7BC243"
          @click="openCreateDialog"
          class="white--text cataloguebtn"
          >Create Warehouse Charge</v-btn
        >
      </v-col>
    </v-row>
    <v-layout class="main-layout">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span
                  class="accent--text"
                  style="font-size: 14px; font-weight: 700"
                >
                  Warehouse Charges
                </span>
                <v-spacer v-if="userId"></v-spacer>
              </v-flex>
              <v-spacer> </v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search"> </v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="rates"
              :items-per-page="5"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:item.actions="{ item }">
                <v-btn
                  class="btn"
                  v-if="
                    canCreateWarehouseCharge &&
                    item['status']['statusName'] == 'PENDING_CHECKER_APPROVAL'
                  "
                  @click="editWarehouseCharge(item)"
                  color="primary"
                >
                  Edit
                </v-btn>





              </template>
			  <template v-slot:item.contractStartDate="{ item }">
                {{ item.contractStartDate | prettyDate }}
              </template>
              <template v-slot:item.contractEndDate="{ item }">
                {{ item.contractEndDate | prettyDate }}
              </template>
              <template v-slot:item.documentUpload.fileName="{ item }">
                <a
                  href="#"
                  class="primary--text"
                  @click.prevent="downloadContractPDF(item)"
                >
                  {{ item.documentUpload.fileName }}
                </a>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-dialog v-model="createWarehouseChargeDialog" persistent max-width="850">
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text"
              >Create Warehouse Charge</v-card-title
            >
            <v-card-text>
              <v-container grid-list-xl fluid>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap>
                    <v-flex xs6>
                      <v-select
                        label="Grower"
                        item-text="name"
                        item-value="value"
                        v-model="grower"
                        :items="filteredGrowers"
                        variant="solo-filled"
                        solo
                        hide-details
                        return-object
                        dense
                      >
                        <template v-slot:prepend-item>
                          <v-text-field
                            v-model="searchInput"
                            label="Search Grower"
                            solo-inverted
                            hide-details
                          ></v-text-field>
                        </template>
                      </v-select>
                      <label
                        class="custom-form-error grower-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        label="Warehouse"
                        item-text="name"
                        item-value="value"
                        v-model="miller"
                        :items="filteredWarehouse"
                        variant="solo-filled"
                        solo
                        hide-details
                        return-object
                        dense
                      >
                        <template v-slot:prepend-item>
                          <v-text-field
                            v-model="searchInput"
                            label="Search Warehouse"
                            solo-inverted
                            hide-details
                          ></v-text-field>
                        </template>
                      </v-select>
                      <label
                        class="custom-form-error grower-error"
                        for="contract"
                      ></label>
                    </v-flex>

                    <v-flex xs4>
                      <v-text-field
                        label="Bag Rate"
                        min="1"
                        type="number"
                        v-model="bagRate"
                        :error-messages="chargeErrorMessages"
                        @input="validatebagRate"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs4>
                      <v-text-field
                        label="Grace Period"
                        min="1"
                        type="number"
                        v-model="gracePeriod"
                        :error-messages="gracePeriodErrorMessages"
                        @input="validategracePeriod"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Day Bag Rate"
                        min="1"
                        type="number"
                        v-model="perDayPerBagCharge"
                        :error-messages="perDayErrorMessages"
                        @input="validateperDayPerBag"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs4>
                      <label for="contractstartdate">Contract Start Date</label>
                      <input
                        type="date"
                        id="datepicker"
                        label="Units"
                        v-model="contract_start_date"
                        @input="validateEndDate"
                      />
                      <p
                        class="custom-form-error contract-start-date-error"
                        for="contract"
                      ></p>
                    </v-flex>
                    <v-flex xs4>
                      <label for="contractenddate">Contract End Date</label>
                      <input
                        type="date"
                        id="datepicker"
                        label="Units"
                        v-model="contract_end_date"
                        :min="'2024-05-05'"
                      />
                      <p
                        class="custom-form-error contract-end-date-error"
                        for="contract"
                      ></p>
                    </v-flex>
                    <v-flex id="fileupload" xs4>
                      <label for="contract">Contract </label>
                      <input
                        type="file"
                        id="file"
                        ref="file"
                        v-on:change="handleFileUpload()"
                        required
                      />
                      <p
                        class="custom-form-error contract-file-error"
                        for="contract"
                      ></p>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                class="accentd&#45;&#45;text"
                style="font-weight: 700"
                @click="createWarehouseChargeDialog = false"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="createWarehouseCharge"
                >Submit</v-btn
              >
              <v-progress-circular
                v-show="createWarehouseLoader"
                color="red"
                size="20"
                indeterminate
              ></v-progress-circular>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      <v-dialog v-model="editWarehouseChargeDialog" persistent max-width="850">
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text"
              >Update Warehouse Charge</v-card-title
            >
            <v-card-text>
              <v-container grid-list-xl fluid>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout wrap>
					<v-flex xs4>
                      <v-text-field
                        v-model="this.actualGrower"
                        label="Grower"
                        readonly
                      ></v-text-field>
                    </v-flex>
					<v-flex xs4>
                      <v-text-field
                        v-model="this.actualWarehouse"
                        label="Warehouse"
                        readonly
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs4>
                      <v-text-field
                        label="Bag Rate"
                        min="1"
                        type="number"
                        v-model="bagRate"
                      ></v-text-field>
                      <label
                        class="custom-form-error bag-rate-edit-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Grace Period"
                        min="1"
                        type="number"
                        v-model="gracePeriod"
                      ></v-text-field>
                      <label
                        class="custom-form-error grace-period-edit-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        label="Per day per bag charge"
                        min="1"
                        type="number"
                        v-model="perDayPerBagCharge"
                      ></v-text-field>
                      <label
                        class="custom-form-error per-day-per-bag-charge-edit-error"
                        for="contract"
                      ></label>
                    </v-flex>
                    <v-flex xs4>
                      <label for="contractstartdate">Contract Start Date</label>
                      <input
                        type="date"
                        id="datepicker"
                        label="Units"
                        v-model="contract_start_date"
                        @input="validateEndDate"
                      />
                      <p
                        class="custom-form-error contract-start-date-error"
                        for="contract"
                      ></p>
                    </v-flex>
                    <v-flex xs4>
                      <label for="contractenddate">Contract End Date</label>
                      <input
                        type="date"
                        id="datepicker"
                        label="Units"
                        v-model="contract_end_date"
                        :min="contract_start_date"
                      />
                      <p
                        class="custom-form-error contract-end-date-error"
                        for="contract"
                      ></p>
                    </v-flex>

                    <v-flex id="fileupload" xs4>
                      <label for="contract">Contract </label>
                      <input
                        type="file"
                        id="file"
                        ref="file"
                        v-on:change="handleFileUpload()"
                        required
                      />
                      <p
                        class="custom-form-error contract-file-error"
                        for="contract"
                      ></p>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                class="accentd&#45;&#45;text"
                style="font-weight: 700"
                @click="editWarehouseChargeDialog = false"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="updateWarehouseCharge"
                >Submit</v-btn
              >
              <v-progress-circular
                v-show="updateWarehouseLoader"
                color="red"
                size="20"
                indeterminate
              ></v-progress-circular>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      <v-dialog
        v-model="approveRejectMillerChargeDialog"
        persistent
        max-width="500"
      >
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text"
              >Warehouse Charge</v-card-title
            >
            <v-card-text v-if="approveStatus === 1"
              >Do you want to approve the charge?
            </v-card-text>
            <v-card-text v-if="approveStatus === 0"
              >Do you want to reject the charge?
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="white"
                class="accentd&#45;&#45;text"
                style="font-weight: 700"
                @click="approveRejectMillerChargeDialog = false"
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                v-if="approveStatus === 1"
                color="secondary"
                @click="approveWarehouseCharge"
                >Approve</v-btn
              >
              <v-btn
                v-if="approveStatus === 0"
                color="secondary"
                @click="approveWarehouseCharge"
                >Reject</v-btn
              >
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
import config from "../../../config";
import store from "../../../store";
import http from "../../../http";
import { mapState } from "vuex";

export default {
  name: "warehousechargecreate",
  data: function () {
    return {
      filteredRates: [],
      gradeDisabled: true,
      defaultGrower: {
        name: "Grower1",
        value: "Grower1",
      },
      defaultWarehouse: {
        name: "Warehouse1",
        value: "Warehouse1",
      },
      defaultSelectedGrade: {
        name: "None",
        value: "None",
      },
      borrowerType: [
        {
          name: "FCS",
          value: "FCS",
        },
        {
          name: "FCS FARMER",
          value: "FCS_FARMER",
        },
        {
          name: "ESTATE FARMER",
          value: "ESTATE_FARMER",
        },
      ],
      coffeeType: [
        {
          name: "CHERRY",
          value: "CHERRY",
        },
        {
          name: "PARCHMENT",
          value: "PARCHMENT",
        },
        {
          name: "CLEAN COFFEE",
          value: "CLEAN COFFEE",
        },
      ],
      gradeType: [
        {
          name: "None",
          value: "None",
        },
      ],
      gradeTypeEdit: [],
      gradeTypeCherry: [
        {
          name: "None",
          value: "None",
        },
      ],
      gradeTypeParchment: [
        {
          name: "P1",
          value: "P1",
        },
        {
          name: "P2",
          value: "P2",
        },
        {
          name: "P3",
          value: "P3",
        },
      ],
      gradeTypeCleanCoffee: [
        {
          name: "AA",
          value: "AA",
        },
        {
          name: "BB",
          value: "BB",
        },
        {
          name: "C",
          value: "C",
        },
      ],
      rates: [],
      editFarmerType: {},
      editCoffeeType: {},
      editGrade: {},
      editStatus: "",
      cherryRateTemp: { rate: 0, name: "hello" },
      millerObject: {},
      headers: [
        { text: "Grower", value: "grower.societyName" },
        { text: "GrowerCode", value: "grower.growerCode" },
        { text: "Warehouse", value: "org.organisationName" },
        { text: "Bag Rate", value: "bagRate" },
        { text: "Day Bag Rate", value: "dayBagRate" },
        { text: "Grace Period", value: "gracePeriod" },
        { text: "Contract StartDate", value: "contractStartDate" },
        { text: "Contract Enddate", value: "contractEndDate" },
        { text: "Contract", value: "documentUpload.fileName" },
        { text: "Status", value: "status.statusName" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      borrower_type: "",
      coffee_type: "",
      grade: "",
      rate_amount: "",
      rate_amount_edit: "",
      warehouse_id: "",
      approveStatus: 0,
      approveRejectDialogTitle: "Do you want to approve the charge?",
      approveRejectDialogButton: "Approve",
      valid: true,
      message: "",
      snackbar: false,
      snackbarColor: "",
      file: "",
      files: [],
      pagination: { sortBy: "id", descending: true },
      search: "",
      searchInput: "",
      permissions: [],
      previewLoading: false,
      approveloading: false,
      declineloading: false,
      createWarehouseLoader: false,
      updateWarehouseLoader: false,
      paginatedFiles: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: 7,
      page: 1,
      confirmDialog: false,
      confirmFile: {},
      confirmMessage: "",
      action: "",
      rateLimitDialog: false,
      createWarehouseChargeDialog: false,
      editWarehouseChargeDialog: false,
      approveRejectMillerChargeDialog: false,
      userID: 0,
      grower: "",
      miller2: "",
      broker2: "",
      warehouses: [],
      millers: [],
      millersEdit: [],
      miller: "",
      brokers: [],
      broker: "",
      growers: [],
      warehouse: "",
      bagRate: "",
      gracePeriod: "",
	  actualGrower: [],
      actualGrowerCode: "",
	  actualWarehouse: [],
      actualWarehouse: "",
      perDayPerBagCharge: "",
      contract_start_date: "",
      contract_end_date: "",
      organisationType: "",
      organisationId: 0,
      selectedContractStartDate: new Date().toISOString().split("T")[0],
      selectedContractEndDate: new Date().toISOString().split("T")[0],
      chargeErrorMessages: [],
      pocketErrorMessages: [],
      gracePeriodErrorMessages: [],
      perDayErrorMessages: [],
    };
  },
  mounted() {
    this.getWarehouseCharges();
    this.getWarehouse();
    this.getFCS();
    this.getMillers();
    this.getBrokers();
    this.permissions = store.state.user.roleId.permissions;
  },
  watch: {
    search(newVal) {
      this.searchItems();
    },
    files() {
      this.paginatedFiles = this.paginationMethod(
        this.files,
        1,
        this.numberOfItemsPerPage
      );
      this.numberOfLinks = Math.ceil(
        this.files.length / this.numberOfItemsPerPage
      );
    },
    page: function (val) {
      this.paginatedFiles = this.paginationMethod(
        this.files,
        val,
        this.numberOfItemsPerPage
      );
    },
  },
  computed: {
    ...mapState({ user: (state) => state.user }),
    canUploadFarmers: function () {
      return this.hasPerm("CAN_UPLOAD_FARMERS");
    },
    canCreateWarehouseCharge: function () {
      return this.hasPerm("CAN_CREATE_WAREHOUSE_CHARGE");
    },
    canApproveWarehouseCharge: function () {
      return this.hasPerm("CAN_APPROVE_WAREHOUSE_CHARGE");
    },
    canApproveCatalogue: function () {
      return this.hasPerm("CAN_APPROVE_CATALOGUE");
    },
    // filteredList: function () {
    //   if (this.search === '') {
    //     return this.paginatedFiles
    //   } else {
    //     return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
    //   }
    // },
    userId: function () {
      if (this.user) {
        console.log("user - ", this.user);
        console.log("user2 - ", this.user.organisation.id);
        this.organisationType = this.user.organisation.organisationType.name;
        this.organisationId = this.user.organisation.id;
        this.userID = this.user.id;
        return this.user.id;
      }
      return 0;
    },
    filteredGrowers() {
      return this.growers.filter((grower) =>
        grower.value.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    },
    filteredWarehouse() {
      return this.warehouses.filter((warehouse) =>
        warehouse.value.toLowerCase().includes(this.searchInput.toLowerCase())
      );
    },
  },
  methods: {
	downloadContractPDF(file) {
      // Base64 encoded string of a small PDF file
      const base64String = file.documentUpload.file;

      // This function converts a base64 string to a Blob
      function base64ToBlob(base64, type) {
        const binary = atob(base64.replace(/\s/g, ""));
        const len = binary.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
        }
        return new Blob([view], { type: type });
      }

      const blob = base64ToBlob(base64String, "application/pdf");
      const url = window.URL.createObjectURL(blob);

      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.setAttribute(
        "download",
        file.documentUpload.fileName + ".pdf"
      );
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(downloadLink);
    },
    searchItems() {
      // Log the search query
      console.log("Search item", this.search);

      // Filter items based on search query
      if (this.search === "") {
        // If search query is empty, return the original data
        return this.filteredRates;
      } else {
        // If search query is not empty, perform filtering

        const lowerCaseSearch = this.search.toLowerCase();
        return this.rates.filter((result) => {
          // Check if result and its properties are defined before accessing them
          if (result) {
            return result.bagRate
              .toString()
              .toLowerCase()
              .includes(lowerCaseSearch);
            // ||
            // result.amount.toString().toLowerCase().includes(lowerCaseSearch) ||
            // result.custMemoLine1.toString().toLowerCase().includes(lowerCaseSearch)
          }
          return false;
        });
      }
    },
    validatebagRate() {
      const chargeValue = parseInt(this.bagRate);

      if (isNaN(chargeValue) || chargeValue < 0.0) {
        this.chargeErrorMessages = [
          "Rate must be a number greater or equal to 0 ",
        ];
      } else {
        this.chargeErrorMessages = [];
      }
    },

    validategracePeriod() {
      const chargeValue = parseInt(this.gracePeriod);

      if (isNaN(chargeValue) || chargeValue < 0.0) {
        this.gracePeriodErrorMessages = [
          "Value must be a number greater than or equal to 0 ",
        ];
      } else {
        this.gracePeriodErrorMessages = [];
      }
    },

    validateperDayPerBag() {
      const chargeValue = parseInt(this.perDayPerBagCharge);

      if (isNaN(chargeValue) || chargeValue < 0.0) {
        this.perDayErrorMessages = [
          "Value must be a number greater than or equal to 0 ",
        ];
      } else {
        this.perDayErrorMessages = [];
      }
    },

    validateEndDate() {
      // Validate end date against start date
      console.log("nn-> = s", this.contract_start_date);
      if (
        this.contract_end_date &&
        this.contract_start_date > this.contract_end_date
      ) {
        this.contract_end_date = this.contract_start_date;
      }
    },
    getWarehouse: function () {
		if (this.user.organisation.organisationType.name === "WAREHOUSE") {
        // Use data from user.organisation
        this.warehouses.push({
          name:
            this.user.organisation.organisationName +
            " - " +
            this.user.organisation.organisationCode,
          value: this.user.organisation.organisationCode,
        });
      }else{
		const url = config.serverURI + "/organization/getWarehouse";
      axios
        .post(url)
        .then((response) => {
          response.data.forEach((x) => {
            this.warehouses.push({
              name: x.name + " " + " -" + " " + x.warehouseCode,
              value: x.warehouseCode,
            });
          });

          // this.warehouses = response.data
          console.log("warehouse --- ", response.data);
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
        });
      return this.organisations;
	  }

    },
    getFCS() {
		if (this.user.organisation.organisationType.name === "FARMER_SOCIETY"||this.user.organisation.organisationType.name === "ESTATE" ) {
        // Use data from user.organisation
        this.growers.push({
          name:
            this.user.organisation.organisationName +
            " - " +
            this.user.organisation.organisationCode,
          value: this.user.organisation.organisationCode,
        });
      }else{const url = config.serverURI + "/organization/get-fcs";
      axios
        .get(url)
        .then((response) => {
          console.log("FCS>>>>", response.data);
          // this.growers = response.data
          response.data.forEach((x) => {
            this.growers.push({
              name: x.organisationName + " " + " -" + " " + x.organisationCode,
              value: x.organisationCode,
            });
          });
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.message,
          });
        });

	  }

    },

    getMillers: function () {
      const url = config.serverURI + "/organization/getMillers";
      axios
        .post(url)

        .then((response) => {
          response.data.forEach((x) => {
            console.log("xid => ", x.millerId);
            this.millers.push({ name: x.name, value: x.millerId });
            this.millersEdit.push({ name: x.name, value: x.name });
          });

          console.log("Millers", response.data);
          // this.millers = response.data
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
        });
      return this.organisations;
    },
    getBrokers() {
      var url = config.serverURI + "/organization/getBrokers";
      axios
        .post(url)
        .then((response) => {
          if (response.status !== 200) {
            console.log("Error is " + this.error);
            return;
          }
          response.data.forEach((x) => {
            console.log("brokerCode", x.brokerCode);
            this.brokers.push({ name: x.name, value: x.brokerId });
          });
          // this.brokers = response.data
          console.log("Brockers:====> " + JSON.stringify(response.data));
        })
        .catch((error) => {
          console.log("error", error.response);
        });
    },
    canBeApproved(item) {
      return item.status.id === 3 && this.hasPerm("CAN_APPROVE_FARMERS");
    },
    canBeDeclined(item) {
      return item.status.id === 3 && this.hasPerm("CAN_APPROVE_FARMERS");
    },
    paginationMethod(items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1;
      const from = pageNumber * limitPerPage;
      let to = (pageNumber + 1) * limitPerPage;
      if (to >= items.length) {
        to = items.length;
      }
      return items.slice(from, to);
    },
    hasPerm(permission) {
      return this.permissions.includes(permission);
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    openCreateDialog() {
      this.createWarehouseChargeDialog = true;
    },
    createWarehouseCharge() {
      console.log("hello world tt");

      const grower = this.grower.value;
      const miller = this.miller.value;

      const bagRate = this.bagRate;
      const gracePeriod = this.gracePeriod;
      const perDayPerBagCharge = this.perDayPerBagCharge;
      const contractStartDate = this.contract_start_date;
      const contractEndDate = this.contract_end_date;

      console.log(
        grower,
        miller,
        bagRate,
        gracePeriod,
        perDayPerBagCharge,
        contractStartDate,
        contractEndDate
      );

      $(".custom-form-error").css("display", "none");

      if (grower === "") {
        $(".grower-error").css("display", "inline");
        $(".grower-error").text("Please select grower");
        return;
      }

      if (miller === "") {
        $(".miller-error").css("display", "inline");
        $(".miller-error").text("Please select miller");
        return;
      }

      if (bagRate === "") {
        $(".bag-rate-error").css("display", "inline");
        $(".bag-rate-error").text("Please enter bag rate");
        return;
      }

      if (gracePeriod === "") {
        $(".grace-period-error").css("display", "inline");
        $(".grace-period-error").text("Please enter grace period");
        return;
      }

      if (perDayPerBagCharge === "") {
        $(".per-day-per-bag-charge-error").css("display", "inline");
        $(".per-day-per-bag-charge-error").text(
          "Please enter per day per bag charge"
        );
        return;
      }

      if (contractStartDate === "") {
        $(".contract-start-date-error").css("display", "block");
        $(".contract-start-date-error").text(
          "Please select contract start date"
        );
        return;
      }

      if (contractEndDate === "") {
        $(".contract-end-date-error").css("display", "block");
        $(".contract-end-date-error").text("Please select contract end date");
        return;
      }

      if (this.file.length === 0) {
        $(".contract-file-error").css("display", "block");
        $(".contract-file-error").text("Please upload file");
        return;
      }

      if (new Date(contractStartDate) > new Date(contractEndDate)) {
        $(".contract-end-date-error").css("display", "block");
        $(".contract-end-date-error").text(
          "Contract start date is greater than end date"
        );
        return;
      }
      this.createWarehouseLoader = true;
      const urlUpload = config.serverURI + "/warehouse/upload";

      const formData = new FormData();
      formData.append("file", this.file);

      axios({ url: urlUpload, method: "POST", data: formData })
        .then((response) => {
          if (response.data.error !== false) {
            this.createWarehouseLoader = false;
            $(".contract-file-error").css("display", "block");
            $(".contract-file-error").text(
              "Something went wrong, please try again"
            );
            return;
          }
          const fileId = response.data.message;
          console.log("fileId ## ", fileId);
          var url =
            config.serverURI +
            "/warehouse/create?userId=" +
            this.userID +
            "&fileId=" +
            fileId +
            "&grower=" +
            grower +
            "&miller=" +
            miller +
            "&bagRate=" +
            bagRate +
            "&gracePeriod=" +
            gracePeriod +
            "&perDayPerBag=" +
            perDayPerBagCharge +
            "&contractStartDate=" +
            contractStartDate +
            "&contractEndDate=" +
            contractEndDate;

          axios
            .post(url, {})
            .then((response) => {
              var data = response.data;
              var checkError = data.error;
              this.createWarehouseChargeDialog = false;
              console.log("checkError ", checkError);

              this.createWarehouseLoader = false;
              if (checkError !== undefined) {
                this.message = data.message;
                this.snackbar = true;
                this.snackbarColor = "error";
                return;
              }

              this.grower = "";
              this.miller = "";
              this.bagRate = "";
              this.gracePeriod = "";
              this.perDayPerBagCharge = "";
              this.contract_start_date = "";
              this.contract_end_date = "";

              this.message = "Successfully added warehouse charge";
              this.snackbar = true;
              this.snackbarColor = "primary";
              this.getWarehouseCharges();
            })
            .catch((error) => {
              this.bagRate = "";
              this.gracePeriod = "";
              this.perDayPerBagCharge = "";
              this.contract_start_date = "";
              this.contract_end_date = "";

              this.createWarehouseLoader = false;
              this.message = "Something went wrong, please try again";
              this.snackbar = true;
              this.snackbarColor = "error";
            });
        })
        .catch((error) => {
          $(".contract-file-error").css("display", "block");
          $(".contract-file-error").text(error.response.data.message);
        })
        .finally(() => {
          this.showProgressBar = false;
        });
    },
    approveRejectChargeShowDialog(item, status) {
      console.log(item);
      console.log(status);
      this.approveStatus = status;
      this.warehouse_id = item.id;
      this.approveRejectMillerChargeDialog = true;
    },
    editWarehouseCharge(item) {
      console.log("ITM22 -> ", item);
      $(".custom-form-error").css("display", "none");
      this.editWarehouseChargeDialog = true;
      this.millerObject = item;
	  this.actualGrower = item.grower.growerCode +'-'+item.grower.societyName;
	  this.actualGrowerCode = item.grower.growerCode;
      this.actualWarehouse = item.org.organisationCode+'-'+item.org.organisationName
	  this.miller=item.org.organisationCode
      // this.broker = item.broker.brokerId
      // this.warehouse = item.warehouse.name
      this.bagRate = item.bagRate;
      this.gracePeriod = item.gracePeriod;
      this.perDayPerBagCharge = item.dayBagRate;
      this.contract_start_date = item.contractStartDate;
      this.contract_end_date = item.contractEndDate;
      this.editStatus = item.status.statusName;
      this.rate_amount_edit = item.rate;
      this.warehouse_id = item.id;

      const startDate = new Date(this.contract_start_date);
      const endDate = new Date(this.contract_end_date);
      const parseStartDate = new Date(
        startDate.getTime() + Math.abs(startDate.getTimezoneOffset() * 60000)
      )
        .toISOString()
        .split("T")[0];
      const parseEndDate = new Date(
        endDate.getTime() + Math.abs(endDate.getTimezoneOffset() * 60000)
      )
        .toISOString()
        .split("T")[0];

      this.selectedContractStartDate = parseStartDate;
      this.selectedContractEndDate = parseEndDate;
    },
    getWarehouseCharges() {
      console.log("orgTYPE ", this.organisationType.toUpperCase());
      let url = "/warehouse/findAll"
    //     "/warehouse/findAllOrderByOrganisationId?organisationId=" +
    //     this.organisationId;
    //   // let url = '/warehouse/findAll'

    //   if (this.organisationType.toUpperCase() !== "WAREHOUSE") {
    //     url = "/warehouse/findAll";
    //   }

      console.log("url --------", url);

      http
        .get(config.serverURI + url)
        .then((response) => {
          this.rates = response.data;
          console.log("RR -> ", response.data);
        })
        .catch((error) => {
          console.log("error", error);
          this.$store.dispatch(
            "alert/displayAlert",
            {
              snackbar: true,
              color: "error",
              message: error.response
                ? error.response.data.message
                : "Error ocurred",
            },
            { root: true }
          );
        });
    },

    updateWarehouseCharge() {
      const grower = this.actualGrowerCode;
      const miller = this.miller;
      const broker = this.broker;
      const bagRate = this.bagRate;
      const gracePeriod = this.gracePeriod;
      const perDayPerBagCharge = this.perDayPerBagCharge;
      const contractStartDate = this.contract_start_date;
      const contractEndDate = this.contract_end_date;

      console.log("Data>>",
        grower,
        miller,
        broker,
        bagRate,
        gracePeriod,
        perDayPerBagCharge,
        contractStartDate,
        contractEndDate
      );

      $(".custom-form-error").css("display", "none");

      if (grower === "") {
        $(".grower-edit-error").css("display", "inline");
        $(".grower-edit-error").text("Please select grower");
        return;
      }

      if (miller === "") {
        $(".miller-edit-error").css("display", "inline");
        $(".miller-edit-error").text("Please select miller");
        return;
      }


      if (bagRate === "") {
        $(".bag-rate-edit-error").css("display", "inline");
        $(".bag-rate-edit-error").text("Please enter bag rate");
        return;
      }

      if (gracePeriod === "") {
        $(".grace-period-edit-error").css("display", "inline");
        $(".grace-period-edit-error").text("Please enter grace period");
        return;
      }

      if (perDayPerBagCharge === "") {
        $(".per-day-per-bag-charge-edit-error").css("display", "inline");
        $(".per-day-per-bag-charge-edit-error").text(
          "Please enter per day per bag charge"
        );
        return;
      }

      if (contractStartDate === "") {
        $(".contract-start-date-edit-error").css("display", "inline");
        $(".contract-start-date-edit-error").text(
          "Please enter contract start date"
        );
        return;
      }

      if (contractEndDate === "") {
        $(".contract-end-date-edit-error").css("display", "inline");
        $(".contract-end-date-edit-error").text(
          "Please enter contract end date"
        );
        return;
      }

      if (
        new Date(this.selectedContractStartDate) >
        new Date(this.selectedContractEndDate)
      ) {
        $(".contract-end-date-edit-error").css("display", "block");
        $(".contract-end-date-edit-error").text(
          "Contract start date is greater than end date"
        );
        return;
      }

      $(".custom-form-error").css("display", "none");

      if (
        grower !== "" ||
        miller !== "" ||
        bagRate !== "" ||
        gracePeriod !== "" ||
        perDayPerBagCharge !== "" ||
        contractStartDate !== "" ||
        contractEndDate !== ""
      ) {
        this.updateWarehouseLoader = true;
        if (this.file.length === 0) {
          var url =
            config.serverURI +
            "/warehouse/update?userId=" +
            this.userID +
            "&warehouseId=" +
            this.warehouse_id +
            "&grower=" +
            grower +
            "&miller=" +
            miller +
            "&bagRate=" +
            bagRate +
            "&gracePeriod=" +
            gracePeriod +
            "&perDayPerBag=" +
            perDayPerBagCharge +
            "&contractStartDate=" +
            this.selectedContractStartDate +
            "&contractEndDate=" +
            this.selectedContractEndDate +
            "&fileId=0";
          this.warehouseChargeUpdateReq(url);
        } else {
          const urlUpload = config.serverURI + "/warehouse/upload";

          const formData = new FormData();
          formData.append("file", this.file);

          axios({ url: urlUpload, method: "POST", data: formData })
            .then((response) => {
              if (response.data.error !== false) {
                $(".contract-file-error").css("display", "block");
                $(".contract-file-error").text(
                  "Something went wrong, please try again"
                );
                return;
              }
              const fileId = response.data.message;
              console.log("fileId ## ", fileId);
              var url =
                config.serverURI +
                "/warehouse/update?userId=" +
                this.userID +
                "&warehouseId=" +
                this.warehouse_id +
                "&grower=" +
                grower +
                "&miller=" +
                miller +
                "&bagRate=" +
                bagRate +
                "&gracePeriod=" +
                gracePeriod +
                "&perDayPerBag=" +
                perDayPerBagCharge +
                "&contractStartDate=" +
                this.selectedContractStartDate +
                "&contractEndDate=" +
                this.selectedContractEndDate +
                "&fileId=" +
                fileId;
              this.warehouseChargeUpdateReq(url);
            })
            .catch((error) => {
              $(".contract-file-error").css("display", "block");
              $(".contract-file-error").text(error.response.data.message);
            })
            .finally(() => {
              this.showProgressBar = false;
            });
        }
      } else {
        this.message = "Please enter all fields";
        this.snackbar = true;
        this.snackbarColor = "error";
      }
    },
    warehouseChargeUpdateReq(url) {
      axios
        .put(url, {})
        .then((response) => {
          var data = response.data;
          var checkError = data.error;
          this.updateWarehouseLoader = false;
          this.editWarehouseChargeDialog = false;
          console.log("checkError ", checkError);

          this.approveloading = false;
          if (checkError !== undefined) {
            this.message = data.message;
            this.snackbar = true;
            this.snackbarColor = "error";
            return;
          }

          this.bagRate = "";
          this.gracePeriod = "";
          this.perDayPerBagCharge = "";
          this.contract_start_date = "";
          this.contract_end_date = "";

          this.message = "Successfully updated warehouse charge";
          this.snackbar = true;
          this.snackbarColor = "primary";
          this.getWarehouseCharges();
        })
        .catch((error) => {
          this.approveloading = false;
          this.rateLimitDialog = false;
          this.updateWarehouseLoader = false;
          this.message = "Something went wrong, please try again";
          this.snackbar = true;
          this.snackbarColor = "error";
        });
    },
    approveWarehouseCharge() {
      const warehouseId = this.warehouse_id;
      if (warehouseId !== "") {
        var url =
          config.serverURI +
          "/warehouse/approve?userId=" +
          this.userID +
          "&warehouseId=" +
          warehouseId +
          "&status=" +
          this.approveStatus +
          "&organisationType=" +
          this.organisationType;
        axios
          .put(url, {})
          // .post(url, {params: { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount }})
          // .post(url, { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount })
          .then((response) => {
            var data = response.data;
            var checkError = data.error;
            this.approveRejectMillerChargeDialog = false;
            console.log("checkError ", checkError);
            if (checkError !== undefined) {
              this.message = data.message;
              this.snackbar = true;
              this.snackbarColor = "error";
              return;
            }
            let msg = "Successfully approved warehouse charge";
            if (this.approveStatus === 0) {
              msg = "Successfully rejected warehouse charge";
            }
            this.message = msg;
            this.snackbar = true;
            this.snackbarColor = "primary";
            this.getWarehouseCharges();
          })
          .catch((error) => {
            this.approveRejectMillerChargeDialog = false;
            this.message = "Something went wrong, please try again";
            this.snackbar = true;
            this.snackbarColor = "error";
          });
      } else {
        this.message = "Please enter all checkoffSettlementDetails";
        this.snackbar = true;
        this.snackbarColor = "error";
      }
    },
  },
};
</script>
<style>
.custom-form-error {
  display: none;
  color: red;
}
.main-layout {
  margin-top: 15px;
}
.farmers_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.btn {
  padding: 5px;
  margin: 2px;
  font-size: 12px;
}
.farmers_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.thead {
  background-color: #00513b !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733d29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733d29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #f2d0a7;
  color: #733d29;
}
.pagination > li.active > .page-link {
  background: #00513b;
  color: #fff;
}

select {
  border: 1px solid #000;
  color: black;
  padding: 10px;
}

v-col {
  border: 1px solid brown;
}
</style>
